/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import React, { ReactElement } from 'react';

import type { InferPropTypes } from '@agilemd/ui-utils';

import Fallback from './Fallback/index.ts';

const propTypes = {
  children: PropTypes.node.isRequired
};

export type ErrorBoundaryProps = InferPropTypes<typeof propTypes, never>;

/**
 * Catches errors during render of anything in the subtree, will show an alert on error
 */
const ErrorBoundary: React.FC<ErrorBoundaryProps> = React.memo(
  ({ children }: ErrorBoundaryProps) => (
    <Sentry.ErrorBoundary fallback={Fallback as unknown as ReactElement}>
      {children}
    </Sentry.ErrorBoundary>
  )
);

export default ErrorBoundary;
